import e from "express";

interface YouTubeMessageEvent extends MessageEvent {
    data: string;
}
type YouTubeMessageDataDecoded = {
    "event": "infoDelivery",
    "info": {
        "currentTime": number,
        "videoBytesLoaded": number,
        "videoLoadedFraction": number,
        "currentTimeLastUpdated_": number,
        "playbackRate": number,
        "mediaReferenceTime": number
    },
    "channel": "widget"
} ;
export class YoutubeApi{
    // private readonly handlers = new Map<EventType, Function[]>();
    // public on(event: EventType, handler: any){
    //     if(this.handlers.has(event)) this.handlers.get(event)!.push(handler);
    //     else this.handlers.set(event, [handler]);
    // }
    private _currentPost: number = 0;
    public handleEvent(event: YouTubeMessageEvent){
        if(!event.origin.includes('youtube.com')) return;
        const json = JSON.parse(event.data) as YouTubeMessageDataDecoded;
        if(json.event === 'infoDelivery'){
            if('currentTime' in json.info) this._currentPost = json.info.currentTime;
        }
    }
    public static readonly Instance = new YoutubeApi();

    public sendMessageToPlayer(message: any) {
        for (const el of this.players) {
            el.contentWindow!.postMessage(JSON.stringify(message), '*');
        }
    }
    private get players(){
        return Array.from($("#player")) as HTMLIFrameElement[];
    }
    public get currentPos(){
        return this._currentPost;
    }

    public startListening() {
        this.sendMessageToPlayer({event: 'listening'})
        for(const pl of this.players) pl.onload = ()=>this.sendMessageToPlayer({event: 'listening'});
    }
}

window.addEventListener('message', ev=>YoutubeApi.Instance.handleEvent(ev), false);
$(()=>{
    YoutubeApi.Instance.startListening()
})